export default "__VITE_ASSET__DQNBdZhG__"